import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pathname, setPathname] = useState(window.location.pathname);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10);
        window.addEventListener("scroll", onScroll);

        const onPopState = () => setPathname(window.location.pathname);
        window.addEventListener("popstate", onPopState);

        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("popstate", onPopState);
        };
    }, []);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
    ];

    return (
        <header
            className={`
        fixed top-0 left-0 w-full z-50
        transition-all duration-300
        ${scrolled ? "bg-gray-300 backdrop-blur shadow-lg" : "bg-gray-200"}
      `}
        >
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                {/* Logo */}
                <Link to="/" className="flex-shrink-0">
                    <img
                        src="/logo.png"
                        alt="Primos-Car Logo"
                        className="h-24 w-auto"
                    />
                </Link>

                {/* Navegação desktop */}
                <nav className="hidden md:flex gap-8 text-sm font-semibold uppercase tracking-wide">
                    {navLinks.map((link) => (
                        <Link
                            key={link.href}
                            to={link.href}
                            className={`
                relative text-black/80 hover:text-black transition
                ${pathname === link.href ? "text-black" : ""}
              `}
                        >
                            {link.label}
                            {pathname === link.href && (
                                <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-black" />
                            )}
                        </Link>
                    ))}
                </nav>

                {/* CTA desktop */}
                <div className="hidden md:block">
                    <Link
                        to="/contato"
                        className="
              border border-black
              px-5 py-2
              rounded-full
              text-sm font-semibold
              text-black
              hover:bg-black hover:text-white
              transition
            "
                    >
                        Fale Conosco
                    </Link>
                </div>

                {/* Menu mobile */}
                <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="md:hidden text-3xl text-black"
                >
                    {menuOpen ? <HiX /> : <HiMenu />}
                </button>
            </div>

            {/* Menu mobile dropdown */}
            {menuOpen && (
                <div className="md:hidden bg-gray-900 border-t border-black/10">
                    <ul className="flex flex-col px-6 py-6 gap-4 text-black text-sm font-semibold uppercase">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className={`block ${pathname === link.href ? "opacity-100" : "opacity-70"
                                        }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
